// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608111754/js/" + chunkId + "." + {"44":"a61840d1","225":"6decf135","481":"dabba786","486":"fdd19289","770":"8a2cb708"}[chunkId] + ".0.5795390716007636.chunk.js";
};